export default __webpack_public_path__ + "static/media/IMG_0218.67f38e55.jpg";